export default function traverseChildren(node, accumulatedChildren = []) {
  let componentSiblings = [];

  if (node.sibling) {
    componentSiblings = traverseChildren(node.sibling, []);
  }

  return node.child
    ? [...accumulatedChildren, node, ...componentSiblings, ...traverseChildren(node.child, [])]
    : [...accumulatedChildren, node, ...componentSiblings];
}
